export const send_receive_tab = "mHUWdc";
export const folder_tab = "MnbBN";
export const newFolder_Button = "PhfLSc";
export const newSearchFolder_Button = "DDXF0c";
export const folderPermissions_Button = "hUA5Fc";
export const sendReceiveAllFolders_Button = "yxAKfe";
export const workOffline_Button = "zjYaTb";
export const teams_ChatAroundEmailButton = "aqvkt";
export const teams_ChatAroundEmailAllButton = "pbjhO";
export const Teams_ChatAroundEmailFlyoutButton = "deBoRb";
export const instantMessage_Button = "Ngfxjc";
export const teams_ShareToTeamsChatButton = "TJ1aSd";
export const copyToButton = "oEzwRb";
export const myDayButton = "O3kuid";
export const toDoBarButton = "$ps5V";
export const currentViewButton = "ILJKpb";
export const conversationSettingsButton = "_wy9rb";
export const messagePreviewWin32Button = "I$Hgfe";
export const useTighterSpacingButton = "fcgxye";
export const myDayMenuShow = "yURwte";
export const myDayMenuHide = "BbFiue";
export const unifiedInboxSettingsButton = "HmSCDe";
export const folderSettingsButton = "D5ezCb";
export const favoriteSettingsButton = "Hy39K";
export const customSortButton = "n_4eBe";
export const lightRPOnButton = "BVoWLb";
export const lightRPOffButton = "ltagUd";
export const messageListOrganizationButton = "c8LOsc";
export const classicIndentedViewButton = "wnFajb";
export const readingPaneMessageViewButton = "AyFE9c";
export const createQuickStep_Button = "UjaL4";
export const allApps_Button = "CdCLSe";
export const move_Button_Win32 = "K0T9v";
export const newEmail_Button = "hLr9yb";
export const newItems_Button = "ptGv8d";
export const unreadRead_Button = "E1m5ne";
export const browseGroups_Button_Win32 = "pGOiOb";
export const newGroup_Button_Win32 = "MCqIMd";
export const newGroupDisabled_Tooltip = "BMadld";
export const focusedInbox_Button = "oEP2ib";
export default {send_receive_tab,folder_tab,newFolder_Button,newSearchFolder_Button,folderPermissions_Button,sendReceiveAllFolders_Button,workOffline_Button,teams_ChatAroundEmailButton,teams_ChatAroundEmailAllButton,Teams_ChatAroundEmailFlyoutButton,instantMessage_Button,teams_ShareToTeamsChatButton,copyToButton,myDayButton,toDoBarButton,currentViewButton,conversationSettingsButton,messagePreviewWin32Button,useTighterSpacingButton,myDayMenuShow,myDayMenuHide,unifiedInboxSettingsButton,folderSettingsButton,favoriteSettingsButton,customSortButton,lightRPOnButton,lightRPOffButton,messageListOrganizationButton,classicIndentedViewButton,readingPaneMessageViewButton,createQuickStep_Button,allApps_Button,move_Button_Win32,newEmail_Button,newItems_Button,unreadRead_Button,browseGroups_Button_Win32,newGroup_Button_Win32,newGroupDisabled_Tooltip,focusedInbox_Button};